import { ContractType } from '../../types/ContractType'

export const contractTypeMap = new Map<ContractType, string>([
  ['alternance', 'Alternance'],
  ['cdd', 'CDD'],
  ['cdi', 'CDI'],
  ['internship', 'Stage'],
])

/**
 * Get offers with contract type 'alternance' or 'internship'
 * @param offers - Array of offers
 * @returns Array of offers with contract type 'alternance' or 'internship'
 */
export function getIntershipAndAlternanceOffers<T extends { contractType: ContractType | null }>(offers: T[]) {
  if (!offers || !offers?.length) {
    return []
  }

  return offers.filter((offer) =>
    offer.contractType?.toLowerCase() === 'alternance' ||
    offer.contractType?.toLowerCase() === 'internship'
  )
}

/**
 * Get all offers excepted intership and alternance offers
 * @param offers - Array of offers
 * @returns Array of offers excepted intership and alternance offers
 */
export function getAllOffersExceptedIntershipAndAlternance<T extends { contractType: ContractType | null }>(offers: T[]) {
  if (!offers || !offers?.length) {
    return []
  }

  return offers.filter((offer) =>
    offer.contractType?.toLowerCase() !== 'alternance' &&
    offer.contractType?.toLowerCase() !== 'internship'
  )
}
